import React from "react";

export default function About() {
  return (
    <div data-testid="about-page" className="bg-ink text-white pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-mono text-xs uppercase tracking-[0.4em] text-adrenaline">Who We Are</div>
        <h1 className="text-display text-6xl md:text-8xl uppercase leading-none mt-3">Texas Born. Street Official.</h1>
        <div className="section-divider mt-12" />
        <div className="prose prose-invert max-w-none mt-12 space-y-6 text-zinc-300 text-lg leading-relaxed">
          <p>Lone Star Speed was built in a Houston garage by two friends who got tired of seeing the same generic wheels and overpriced rebrands at every meet. We wanted gear that meant something — engineered for the strip, designed for the street, and made in limited runs you'd actually be proud to own.</p>
          <p>Every wheel is forged in small batches. Every garment is built heavy and meant to last. Every drop sells out, and we don't restock. If you missed it, you missed it.</p>
          <p className="text-adrenaline text-heading uppercase tracking-wider">No mass production. No restocks. No imitations.</p>
          <p>From the strip in Houston to night runs in Dallas to Austin meets — Lone Star Speed is the uniform of the Texas car scene. Limited drops for people who live speed, street cars, and drag racing culture.</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-1 mt-16">
          {[
            { k: "Founded", v: "Houston, TX" },
            { k: "Drops/Year", v: "4–6" },
            { k: "Wheel Sizes", v: "17″–22″" },
            { k: "Best 1/4 Mile", v: "9.8 sec" },
          ].map((s) => (
            <div key={s.k} className="bg-carbon p-6 border border-white/5">
              <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">{s.k}</div>
              <div className="text-display text-3xl mt-3 text-white">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
